export default function (state, data) {
    if (!data) return;
    for (let k in data) {
        if (typeof state[k] !== 'undefined') state[k] = data[k];
    }
}